import { isDemoMode } from './runtimeMode';

const WCB_DASHBOARD_ACCESS_EMAILS = new Set([
  'irisj@diamondvalley.town',
  'lzeer@diamondvalley.town'
]);

const DEMO_WCB_DASHBOARD_ACCESS_EMAILS = new Set([
  '3p3cao@gmail.com',
  'ctdemo.cao@proton.me'
]);

export const hasWcbDashboardAccessEmail = (email) => {
  const normalizedEmail = String(email || '').trim().toLowerCase();
  return WCB_DASHBOARD_ACCESS_EMAILS.has(normalizedEmail)
    || (isDemoMode() && DEMO_WCB_DASHBOARD_ACCESS_EMAILS.has(normalizedEmail));
};

export const getWcbDashboardAccessEmails = () => [...WCB_DASHBOARD_ACCESS_EMAILS];